module.exports = __webpack_public_path__ + "static/media/ic-no task list.41950980.svg";